<template>
   <div class="BasicPage_Toptree_Markets">
            <div class="MoreDivInLine_16 col-12" v-for="(item, index) in temp_value">
                  <div class="MoreDivInLine_Row" >
                    <selection :ContolId="'exportType_'+index"
                      :title="$t('lbl_EMPBE_PleaseSelect')"
                      v-model="item.exportType" 
                      label="text" 
                      :options="FilterSelect(item)">
                    </selection>
                  </div>
                  <div class="MoreDivInLine_Row">
                <textbox 
                    :ContolId="'percentageId_'+index"
                    type="number" 
                    v-model="item.percentageId" 
                    max="100"
                    AllowInt="true"
                    NoMultipleMin="false"
                    :title="$t('lbl_EMPBE_CompanyInfo_Basic_ExportPercentage')"
                    @CustomChange="CustomChange($event,item)"
                    >
                </textbox>
                  </div>
                  <div>
                    <div class="percentage">%</div>
                  </div>
            </div>  
   </div> 
</template>
<script>
export default {
    props: ["value","MarketOptions","nums"],
    data(){
        return{
            temp_value:this.value,
            temp_MarketOptions:this.MarketOptions
        }
    },
    watch:{
        value() {
            this.temp_value = this.value;
        },
        temp_Value: {
            handler() 
            {
                this.$emit("input",this.temp_Value);

            },deep:true
        },
        MarketOptions:
        { 
            handler() 
            {
                this.temp_MarketOptions=this.MarketOptions;

            },deep:true

        }
    },
    mounted(){
        this.temp_value = this.value;
    },
    computed: 
    {
        SumPercentageId(){
            var sum = this.temp_value.reduce((acc, curr) => {
                    var nums =curr.percentageId ==""? 0:curr.percentageId;
                    return acc+parseInt(nums);
                },0);
            return sum
        }   
    },
    methods: {
        //过滤掉除开自己以外 的所有其他选项已经选项的数据
        FilterSelect(item){
            var list = this.temp_value.filter(a=>a.exportType != item.exportType).map(a=>a.exportType); 
            return this.temp_MarketOptions.filter(a=>!list.includes(a.id));
        },
        CustomChange(val,item){
            var sum = this.SumPercentageId;
            if(sum>100)
            {
                var remainSum = sum - parseInt(val)
                const thenVals  = (remainSum>=100) ? 0 : (val - (sum-100)) ;
                this.$nextTick(()=>{
                    item.percentageId=thenVals;
                })
            }
        }
    }

}
</script>
<style lang="scss" scoped>
</style>